// Detection/Extraction types
export type DrillSide = '+X' | '-X' | '+Y' | '-Y' | '+Z' | '-Z';

/** Canonical order for orientation tabs and sorting: +Z, -Z, +Y, -Y, +X, -X */
export const ORIENTATION_ORDER: readonly DrillSide[] = ['+Z', '-Z', '+Y', '-Y', '+X', '-X'];
export type ExtractionType = 'holes' | 'pockets';
export type HoleBottom = 'DRILL_TIP' | 'FLAT' | 'THROUGH_HOLE';
export type InplaneRotation = 0 | 90 | 180 | 270;

export interface DetectionModel {
  id: string; // UUID
  model_id: string; // UUID
  orientation: DrillSide;
  extraction_type: ExtractionType;
  s3_url_extraction: string;
  created_at: string; // ISO datetime
  updated_at: string; // ISO datetime
  deleted_at?: string; // ISO datetime
}

export interface HoleTolerance {
  // Tolerance data structure (if needed)
  [key: string]: unknown;
}

export interface HoleWCS {
  x_mm: number;
  y_mm: number;
  diameter_mm: number;
  depth_mm: number;
  z_entry_mm: number;
  bottom: HoleBottom;
  color_wall?: string;
  color_bottom?: string;
  color_chamfer?: string;
  chamfer_angle_deg?: number;
  chamfer_diameter_mm?: number;
  chamfer_depth_mm?: number;
  drill_point_angle_deg?: number;
  tol?: HoleTolerance;
}

export interface HoleTransform {
  drill_side: DrillSide;
  inplane_rotation_deg: InplaneRotation;
  offset_after_rotation_mm: {
    x: number;
    y: number;
    z: number;
  };
}

export interface HoleSet {
  transform: HoleTransform;
  holes: HoleWCS[];
}

export interface AllOrientationsHoleSets {
  [orientation: string]: HoleSet; // Keys are DrillSide values
}

// Sort configuration
export type DetectionSortField = 'orientation' | 'created_at' | 'holes_count';
export type DetectionSortOrder = 'asc' | 'desc';

export interface DetectionSortConfig {
  field: DetectionSortField;
  order: DetectionSortOrder;
}
